<template>
  <div class="page-container" style="min-height: 0px; max-width: 630px;">
    <div class="author-container">
      <div class="author-elements-top">

        <div class="author-profile">
          <img class="author-image" :src="profileImageUrl">
          <div class="author-name">
            <div class="name">{{name}}</div>
            <div style="opacity: 0.6;">@{{screenName}}</div>
          </div>
        </div>

        <div style="display: flex; flex-direction: row;">    
          <slot name="right-side">
            <button @click="$router.push({ path: `/author/${id}` })" type="button" class="twitter-follow" style="margin-right: 0px;">
              <i class="fab fa-twitter twitter-follow-icon"></i>
            </button>
          </slot>
        </div>
      

      </div>

      <div class="author-elements-bottom" v-if="showExtra">
        <div>📌 {{description}}</div>
        <div v-if="location !== ''">🌎 {{location}}</div>
        <div>👤 {{followersCount}} followers</div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
    props: [
      'showExtra',
      'profileImageUrl',
      'location',
      'description',
      'followersCount',
      'name',
      'screenName',
      'id',
    ],

    methods: {
      goTo(url){
        const win = window.open(url, '_blank')
        win.focus()
      }
    }
}
</script>

<style scoped>
.page-container{
  max-width: 1100px;
  min-height: 1100px;
  padding: 0 3rem;
  margin: 0 auto;
}
.author-image{
  border-radius: 50% !important;
  width: 54px;
}
.author-container{
  background-color: var(--secondary-light-color);
  margin-top: 2rem;
  border-radius: 8px 8px 0px 0px;
  padding: 0.4rem 1.5rem;
}
.author-elements-top{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 0.4rem;
}

.author-elements-bottom{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  line-height: 26px;
}
.author-profile{
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 0.3rem;
}
.author-name{
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 10px;
  margin-right: 10px;
}
.name{
  font-size: 15px;
  font-weight: bold;
}

@media (max-width: 760px){
  .page-container{
    padding: 0 0.5rem;
  }
  .author-container{
    margin-top: 1.5rem;
    border-radius: 8px 8px 0px 0px;
    padding-left: 0.8rem;
    padding-right: 0.8rem;
    padding-top: 0.4rem;
    padding-bottom: 0.4rem;
  }
  .author-elements-top{
    flex-wrap: wrap;
  }
  .name{
    font-size: 12px;
    font-weight: bold;
  }
  .author-image{
    width: 34px;
}
}
</style>